export type UmpireResourceType =
  | 'competition_season'
  | 'group'
  | 'round'
  | 'squad'
  | 'stage';
